import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import type {
  MaintenanceContractIssue,
  MaintenanceContractIssueCode,
} from '~/app/landing/sla/oems/components/MaintenanceSlaContract/types';
import { hasMaintenanceIssue } from '~/app/landing/sla/oems/components/MaintenanceSlaContract/utils';

function messageFor(
  t: (key: string) => string,
  code: MaintenanceContractIssueCode,
): string {
  switch (code) {
    case 'timerClock':
    case 'timerCalendar':
    case 'scopeInterventionModeRequired':
      return t('validation.required');
    case 'restoredMinutes':
      return t('oems.maintenance.validation.minutesRange');
    case 'pricingCombination':
      return t('oems.maintenance.validation.pricingCombinationRequired');
    case 'pricingCombinationPrice':
      return t('oems.maintenance.validation.pricingCombinationPrice');
    case 'scopeValue':
      return t('oems.maintenance.validation.scopeValue');
    case 'scopeHierarchyRedundancy':
      return t('oems.maintenance.validation.scopeHierarchyRedundancy');
    case 'scopeEffectConflict':
      return t('oems.maintenance.validation.scopeEffectConflict');
    default:
      return t('validation.required');
  }
}

export function useMaintenanceSlaIssueHelp(
  issues: readonly MaintenanceContractIssue[],
) {
  const { t } = useTranslation('sla');

  return useCallback(
    (
      code: MaintenanceContractIssueCode,
      match?: Partial<MaintenanceContractIssue>,
    ) =>
      hasMaintenanceIssue(issues, code, match)
        ? messageFor(t, code)
        : undefined,
    [issues, t],
  );
}
